import React, { useState, useEffect, forwardRef } from "react";

// New：
// Import a centralized event bus to broadcast parsed‐file events across the app
import eventBus from "../utils/eventBus";
// EndNew



import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import CircularProgress from '@mui/material/CircularProgress';
// Radio button imports
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
/***************************************
 * library and worker to read pdf files
 */
import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf";
//import { getDocument } from "pdfjs-dist/legacy/build/pdf";
import parseGrantProposalText from "../utils/parseGrantProposalText";
const pdfjsWorker = require("pdfjs-dist/legacy/build/pdf.worker.entry");
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;
// *************************************


const baseurl = process.env.REACT_APP_API_URL;

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  whiteSpace: "nowrap",
  width: 1,
});



const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: '90%',               
  maxWidth: 1000,            
  bgcolor: "black",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  maxHeight: '90vh',          
  overflow: 'auto',           
  borderRadius: 2
};

// Shared document categories. Existing backend values are retained where they
// already existed so this UI change does not silently relabel legacy uploads.
const DOCUMENT_TYPE_OPTIONS = [
  { value: "grantproposal", label: "Grant Proposal" },
  { value: "grantorFeedback", label: "Grantor's Proposal Feedback" },
  { value: "grantFinancialDoc", label: "Financial Document" },
  { value: "other", label: "Other" },
];

export function FileUploaderDropzone({
  uid,
  grantProposalFormId,
  clientOrganizationId,
  onParsedData,
  onFilesChange,
  // Reports active transfer/parsing state without requiring consumers to
  // inspect the component's internal status records.
  onProcessingChange,
  onExistingFilesChange,
  showExistingFiles = false,
  // Allows the eligibility page to place this shared client-file library
  // inside its dedicated right-hand column without duplicating the UI.
  hideUploader = false,
    // Compact mode is used by the eligibility page to preserve its three-column layout.
  compact = false,
  // Lets a compact consumer reduce its dropzone height without changing compact
  // uploader sizing everywhere else in the application.
  compactHeightClass = "",
    // Keeps upload progress inside the dropzone instead of growing content below it.
  statusInsideDropzone = false,
    // Client-library uploads on Check Eligibility are stored only. Proposal pages
  // may opt into PDF field extraction after upload.
  parseUploadedProposal = true,
  // Uses the dedicated client-library storage endpoint without requiring a
  // proposal ID. Existing proposal upload flows retain their current endpoint.
  clientLibraryMode = false,
  // Lets a consumer make the existing-file library fill a dedicated column.
  fillExistingFilesPanel = false,
  className = "",
}) {
    const [documents, setDocuments] = useState([]);
  const [pendingFiles, setPendingFiles] = useState([]);
  // New uploads must be explicitly classified; no document type is preselected.
  const [selectedDocumentType, setSelectedDocumentType] = useState("");
  const [documentDescription, setDocumentDescription] = useState("");
  const [isTypeModalOpen, setIsTypeModalOpen] = useState(false);
  const [clientFiles, setClientFiles] = useState([]);
  const [selectedExistingFiles, setSelectedExistingFiles] = useState([]);
  const [isLoadingExistingFiles, setIsLoadingExistingFiles] = useState(false);
  const [existingFilesError, setExistingFilesError] = useState("");
    const [isDraggingOver, setIsDraggingOver] = useState(false);
  const inputRef = React.useRef(null);

  // Upload remains unavailable until a type is selected. "Other" additionally
  // requires its description so stored documents always have usable metadata.
  const canConfirmUpload = Boolean(
    pendingFiles.length > 0 &&
    selectedDocumentType &&
    (selectedDocumentType !== "other" || documentDescription.trim())
  );

  const updateDocuments = (updater) => {
    setDocuments((currentDocuments) => {
      const nextDocuments = typeof updater === "function"
        ? updater(currentDocuments)
        : updater;
      return nextDocuments;
    });
  };

    // Notify the parent after document state commits; state updater callbacks
  // must remain pure and should not trigger parent state changes themselves.
    useEffect(() => {
    onFilesChange?.(documents);
    onProcessingChange?.(documents.some((document) =>
      ["pending", "uploading", "parsing"].includes(document.status)
    ));
  }, [documents, onFilesChange, onProcessingChange]);

  const updateDocument = (id, updates) => {
    updateDocuments((currentDocuments) => currentDocuments.map((document) => (
      document.id === id ? { ...document, ...updates } : document
    )));
  };

  const uploadFile = async (document) => {
        // Files belong to the user and client library. A proposal ID is optional
    // because a user can upload before eligibility creates a proposal.
        // Client-library uploads can begin before a proposal exists; proposal uploads cannot.
    if (!uid || !clientOrganizationId || (!clientLibraryMode && !grantProposalFormId)) {
      throw new Error(
        clientLibraryMode
          ? "A user and client must be selected before uploading files."
          : "A user, proposal, and client must be selected before uploading files."
      );
    }

    const uploadData = new FormData();
    uploadData.append("file", document.file);
    uploadData.append("uid", uid);
        // Preserve the existing proposal workflow when a proposal ID is available,
    // but do not require it for client-library uploads.
    if (grantProposalFormId) uploadData.append("grantProposalForm_id", grantProposalFormId);
    uploadData.append("client_Organization_id", clientOrganizationId);
    // This is a user-facing category, distinct from the technical PDF MIME type.
    uploadData.append("document_type", document.documentType);
    uploadData.append("description", document.description);

        // Client-library documents are stored independently of proposal creation.
    const uploadEndpoint = clientLibraryMode
      ? "/gptRun/upload-client-document"
      : "/gptRun/upload-copilot";
    const response = await fetch(`${baseurl}${uploadEndpoint}`, {
      method: "POST",
      body: uploadData,
    });
    const result = await response.json().catch(() => ({}));

    if (!response.ok) {
      // The client-library endpoint returns JSON errors under `error`.
      throw new Error(result.error || result.detail || result.message || "File upload failed.");
    }
    return result;
  };

  const parsePdf = async (file) => {
    const bytes = new Uint8Array(await file.arrayBuffer());
    const pdfDocument = await pdfjsLib.getDocument(bytes).promise;
    const pages = [];

    for (let pageNumber = 1; pageNumber <= pdfDocument.numPages; pageNumber += 1) {
      const page = await pdfDocument.getPage(pageNumber);
      const textContent = await page.getTextContent();
      pages.push(...textContent.items
        .map((item) => item.str)
        .filter((line) => line.trim() !== ""));
    }

    const response = await parseGrantProposalText(pages.join(" "));
    const parsed = typeof response === "string" ? JSON.parse(response) : response;
    eventBus.emit("file:parsed", { name: file.name, data: parsed });
    onParsedData?.({ source: "file", ...parsed });
    };

  const processFile = async (document) => {
    try {
      updateDocument(document.id, { status: "uploading", error: null });
      const uploadResult = await uploadFile(document);
      const uploadedMetadata = uploadResult.metadata || uploadResult;

      // Retain the stable backend ID and storage metadata so parent pages can
      // carry real document references forward after a successful upload.
      updateDocument(document.id, {
        serverDocumentId: uploadResult.id || uploadedMetadata.document_id || null,
        gcpFilePath: uploadedMetadata.gcp_file_path || null,
        storageStatus: uploadedMetadata.storage_status || "stored",
        processingStatus: uploadedMetadata.processing_status || "not_started",
      });

      // Only proposal PDFs are suitable for the proposal-field extraction
      // parser. Feedback and financial documents remain stored references.
      const isPdf = document.file.type === "application/pdf" ||
        document.file.name.toLowerCase().endsWith(".pdf");
      if (parseUploadedProposal && isPdf && document.documentType === "grantproposal") {
        updateDocument(document.id, { status: "parsing" });
        await parsePdf(document.file);
      }

      updateDocument(document.id, { status: "complete" });
    } catch (error) {
      console.error(`Error processing ${document.name}:`, error);
      updateDocument(document.id, { status: "failed", error: error.message });
    }
    };

  // File selection is intentionally separated from upload. The user first
  // confirms a document category in the modal, then the batch is uploaded.
    const addFiles = (files) => {
    const selectedFiles = Array.from(files || []);
    const nextPendingFiles = selectedFiles.filter((file) =>
      file.type === "application/pdf" || file.name.toLowerCase().endsWith(".pdf")
    );

    // The input accept filter does not protect drag-and-drop, so reject
    // unsupported files before opening the document metadata modal.
    if (nextPendingFiles.length !== selectedFiles.length) {
      alert("Only PDF files are supported.");
    }
    if (!nextPendingFiles.length) return;

        // Reset modal-only metadata so every selected batch requires an explicit type.
    setPendingFiles(nextPendingFiles);
    setSelectedDocumentType("");
    setDocumentDescription("");
    setIsTypeModalOpen(true);
  };

    const confirmUpload = () => {
    // Keep validation here as a safeguard in addition to the disabled UI button.
    if (!canConfirmUpload) return;

    if (selectedDocumentType === "other" && !documentDescription.trim()) {
      alert("Please describe documents uploaded as Other.");
      return;
    }

    const newDocuments = pendingFiles.map((file) => ({
      id: `${file.name}-${file.lastModified}-${Date.now()}-${Math.random()}`,
      file,
      name: file.name,
      documentType: selectedDocumentType,
      description: documentDescription.trim(),
      status: "pending",
      error: null,
    }));

        updateDocuments((currentDocuments) => [...currentDocuments, ...newDocuments]);
    setPendingFiles([]);
    setSelectedDocumentType("");
    setDocumentDescription("");
    setIsTypeModalOpen(false);
    newDocuments.forEach(processFile);
  };

    const cancelPendingUpload = () => {
    // Clear all modal-only values before the next file-selection attempt.
    setPendingFiles([]);
    setSelectedDocumentType("");
    setDocumentDescription("");
    setIsTypeModalOpen(false);
  };

  const removeDocument = (id) => {
    updateDocuments((currentDocuments) => currentDocuments.filter((document) => document.id !== id));
  };

  // Existing client files are selected by reference. They are not downloaded
  // and re-uploaded, which prevents accidental duplicate storage objects.
  useEffect(() => {
    if (!showExistingFiles || !uid || !clientOrganizationId) return undefined;

    let isActive = true;
    const fetchClientFiles = async () => {
      setIsLoadingExistingFiles(true);
      setExistingFilesError("");
      try {
        const response = await fetch(`${baseurl}/gptRun/files/${clientOrganizationId}?uid=${encodeURIComponent(uid)}`);
        if (!response.ok) throw new Error(`Unable to load files: ${response.statusText}`);
        const files = await response.json();
        if (isActive) setClientFiles(Array.isArray(files) ? files : []);
      } catch (error) {
        console.error("Failed to fetch previously uploaded files:", error);
        if (isActive) setExistingFilesError("Unable to load previously uploaded files.");
      } finally {
        if (isActive) setIsLoadingExistingFiles(false);
      }
    };

    fetchClientFiles();
    return () => { isActive = false; };
  }, [showExistingFiles, uid, clientOrganizationId]);

  const toggleExistingFile = (file) => {
    const fileKey = file.id || file.gcp_file_path || file.original_filename;
    setSelectedExistingFiles((currentFiles) => {
      const isSelected = currentFiles.some((currentFile) =>
        (currentFile.id || currentFile.gcp_file_path || currentFile.original_filename) === fileKey
      );
      const nextFiles = isSelected
        ? currentFiles.filter((currentFile) =>
          (currentFile.id || currentFile.gcp_file_path || currentFile.original_filename) !== fileKey
        )
        : [...currentFiles, file];
      return nextFiles;
    });
  };

  // Existing-file selection is reported after local state has committed.
  useEffect(() => {
    onExistingFilesChange?.(selectedExistingFiles);
  }, [selectedExistingFiles, onExistingFilesChange]);

  const statusText = (document) => {
    if (document.status === "uploading") return "Uploading…";
    if (document.status === "parsing") return "Extracting PDF data…";
    if (document.status === "complete") return "Uploaded";
    if (document.status === "failed") return document.error || "Upload failed";
    return "Waiting to upload";
    };

  // Existing-file-only mode begins at the parent panel's top padding so its
  // heading aligns with neighboring content.
  return (
    <div className={`flex flex-col items-center ${hideUploader ? "" : "py-8 px-4"} ${className}`}>
      {!hideUploader && (
        <div
          role="button"
          tabIndex={0}
          onKeyDown={(event) => {
            if (event.key === "Enter" || event.key === " ") inputRef.current?.click();
          }}
          onClick={() => inputRef.current?.click()}
          onDragOver={(event) => {
            event.preventDefault();
            setIsDraggingOver(true);
          }}
          onDragLeave={() => setIsDraggingOver(false)}
          onDrop={(event) => {
            event.preventDefault();
            setIsDraggingOver(false);
            addFiles(event.dataTransfer.files);
          }}
          className={`border-2 border-dashed rounded-xl w-full flex flex-col items-center transition-all cursor-pointer overflow-hidden ${
          compact
          ? `${compactHeightClass || "h-[190px]"} max-w-[460px] px-5 ${
                        statusInsideDropzone && documents.length > 0
                          ? "justify-start gap-1 py-2"
                          : "justify-center gap-1 py-3"
                      }`
                      : "p-12 max-w-2xl gap-4"
        } ${
          isDraggingOver
            ? "border-purple-400 bg-purple-900/20"
            : "border-purple-600/50 bg-[#1a0052]/30 hover:border-purple-500 hover:bg-[#1a0052]/50"
                  }`}
        >
          <svg xmlns="http://www.w3.org/2000/svg" className={`${compact ? (statusInsideDropzone && documents.length > 0 ? "h-5 w-5" : "h-8 w-8") : "w-14 h-14"} text-purple-400`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5m-13.5-9L12 3m0 0l4.5 4.5M12 3v13.5" />
          </svg>
            <p style={{ fontFamily: "Roboto, sans-serif", fontSize: compact ? "14px" : "20px" }} className="text-white text-center">
            {statusInsideDropzone && documents.length > 0 ? "Add additional files" : "Drag & drop files here"}
          </p>
          {/* The compact post-upload state reserves this space for its status list. */}
          {!(compact && statusInsideDropzone && documents.length > 0) && (
            <p className={`${compact ? "text-xs" : "text-sm"} text-gray-400`}>or</p>
          )}
          <button
            type="button"
            onClick={(event) => {
              event.stopPropagation();
              inputRef.current?.click();
            }}
            style={{ fontFamily: "Roboto, sans-serif", fontSize: compact ? "14px" : "18px" }}
            className={`bg-[#5e36a3] hover:bg-[#6d60eb] text-white rounded-lg transition-colors select-none ${compact ? "px-5 py-1" : "px-8 py-2"}`}
          >
            Browse Files
          </button>
                    <input
            ref={inputRef}
            type="file"
            multiple
            accept=".pdf"
            className="hidden"
            onChange={(event) => {
              addFiles(event.target.files);
              event.target.value = "";
            }}
          />
          {!(compact && statusInsideDropzone && documents.length > 0) && (
            <p className={`${compact ? "mt-1 text-[10px]" : "text-xs mt-2"} text-gray-500`}>Supports: PDF files only.</p>
          )}

          {/* Fill the remaining fixed-height dropzone space; only this list scrolls after reaching the bottom. */}
          {statusInsideDropzone && documents.length > 0 && (
            <div
              className="flex min-h-0 w-full max-w-md flex-1 flex-col overflow-hidden border-t border-purple-800/40 pt-2"
              onClick={(event) => event.stopPropagation()}
            >
              {/* min-h-0 permits the file list to shrink within the dropzone and overflow vertically. */}
              {/* Offset the dedicated scrollbar toward the panel edge without crowding file names. */}
              <div className="upload-status-scrollbar min-h-0 flex-1 space-y-1 overflow-y-auto pr-2">
                {documents.map((document) => (
                  <div key={document.id} className="flex items-center justify-between gap-2 text-xs">
                    <span className="min-w-0 truncate text-white">{document.name}</span>
                    <span className={document.status === "failed" ? "shrink-0 text-red-300" : "shrink-0 text-gray-400"}>
                      {statusText(document)}
                    </span>
                    <button
                      type="button"
                      onClick={() => removeDocument(document.id)}
                      className="shrink-0 text-gray-400 hover:text-red-400"
                      title="Remove from this list"
                    >
                      X
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}
              </div>
        )}

        {/* Optional client-library panel used by the eligibility page. */}
        {showExistingFiles && (
          <div className={(hideUploader ? "mt-0" : "mt-6") + " w-full max-w-2xl"}> 
            <p className="mb-3 text-center text-sm text-gray-300">Select previously uploaded files</p>
            <div className={(fillExistingFilesPanel ? "h-[334px] max-h-none xl:h-[670px]" : "max-h-64") + " overflow-y-auto rounded-lg border border-purple-800/40 bg-[#1a0052]/30 p-2"}>
              {isLoadingExistingFiles && <p className="p-3 text-center text-sm text-gray-400">Loading files…</p>}
              {existingFilesError && <p className="p-3 text-center text-sm text-red-300">{existingFilesError}</p>}
              {!isLoadingExistingFiles && !existingFilesError && clientFiles.length === 0 && (
                <p className="p-3 text-center text-sm text-gray-400">No previously uploaded files found.</p>
              )}
              {clientFiles.map((file, index) => {
                const fileKey = file.id || file.gcp_file_path || file.original_filename;
                const isSelected = selectedExistingFiles.some((selectedFile) =>
                  (selectedFile.id || selectedFile.gcp_file_path || selectedFile.original_filename) === fileKey
                );
                const fileName = file.original_filename || file.name || "File " + (index + 1);
                                // The selected row color and ring replace the former Select label,
                // preserving full width for long file names.
                return (
                  <button
                    key={fileKey || fileName + "-" + index}
                    type="button"
                    onClick={() => toggleExistingFile(file)}
                    aria-pressed={isSelected}
                    className={(isSelected
                      ? "bg-[#8256ce] ring-1 ring-purple-200"
                      : "bg-[#6034aa] hover:bg-[#7245be]") + " mb-2 flex w-full items-center rounded-md px-3 py-2 text-left text-sm text-white transition-colors"}
                  >
                    <span className="w-full truncate">{fileName}</span>
                  </button>
                );
              })}
            </div>
          </div>
        )}
        

      {!hideUploader && !statusInsideDropzone && documents.length > 0 && (
        <div className="mt-6 w-full max-w-2xl">
          <p style={{ fontFamily: "Roboto, sans-serif" }} className="text-gray-300 text-sm mb-3">
            {documents.length} file{documents.length > 1 ? "s" : ""} selected:
          </p>
          <ul className="space-y-2">
            {documents.map((document) => (
              <li key={document.id} className="flex items-center justify-between bg-[#1a0052]/60 border border-purple-800/40 rounded-lg px-4 py-2">
                <div className="min-w-0 max-w-[80%]">
                  <span style={{ fontFamily: "Roboto, sans-serif", fontSize: "14px" }} className="block text-white truncate">{document.name}</span>
                  <span className={document.status === "failed" ? "block text-xs text-red-300" : "block text-xs text-gray-400"}>{statusText(document)}</span>
                </div>
                <button
                  type="button"
                  onClick={() => removeDocument(document.id)}
                  className="text-gray-400 hover:text-red-400 transition-colors ml-3 text-lg leading-none"
                  title="Remove from this list"
                >
                  ×
                </button>
              </li>
            ))}
          </ul>
        </div>
          )}

      {/* A selected batch must be classified before any file reaches storage. */}
      {!hideUploader && (
      <Modal
        open={isTypeModalOpen}
        onClose={cancelPendingUpload}
        aria-labelledby="document-type-title"
      >
        <Box sx={{ ...modalStyle, maxWidth: 520, bgcolor: "#11002e", borderColor: "#65458e" }}>
          <Typography id="document-type-title" variant="h6" color="white" sx={{ mb: 1 }}>
            Choose document type
          </Typography>
                    {/* This prompt disappears as soon as the required document type is chosen. */}
          {!selectedDocumentType && (
            <Typography color="#ff8a8a" variant="body2" sx={{ mb: 2 }}>
              Please select a document type.
            </Typography>
          )}
          <Box component="ul" sx={{ m: 0, mb: 2, pl: 3, color: "#fff", maxHeight: 120, overflowY: "auto" }}>
            {pendingFiles.map((file) => <li key={`${file.name}-${file.lastModified}`}>{file.name}</li>)}
          </Box>
          <FormControl fullWidth>
            <RadioGroup
              value={selectedDocumentType}
              onChange={(event) => setSelectedDocumentType(event.target.value)}
              name="dropzone-document-type"
            >
              {DOCUMENT_TYPE_OPTIONS.map((type) => (
                <FormControlLabel
                  key={type.value}
                  value={type.value}
                  control={<Radio sx={{ color: "#fff", "&.Mui-checked": { color: "#b58aff" } }} />}
                  label={type.label}
                  sx={{ color: "#fff" }}
                />
              ))}
            </RadioGroup>
          </FormControl>
          <TextField
            label={selectedDocumentType === "other" ? "Description (required)" : "Description (optional)"}
            value={documentDescription}
            onChange={(event) => setDocumentDescription(event.target.value)}
            multiline
            minRows={2}
            fullWidth
            InputLabelProps={{ sx: { color: "#c9b8ef" } }}
            sx={{
              mt: 1,
              textarea: { color: "white" },
              "& .MuiOutlinedInput-notchedOutline": { borderColor: "#7950ad" },
              "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#b58aff" },
            }}
          />
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 3 }}>
            <Button type="button" onClick={cancelPendingUpload} sx={{ color: "#fff" }}>Cancel</Button>
            {/* Disabled styling makes the required type/Other-description validation visible. */}
            <Button
              type="button"
              variant="contained"
              onClick={confirmUpload}
              disabled={!canConfirmUpload}
              sx={{
                bgcolor: "#6942b8",
                "&.Mui-disabled": {
                  bgcolor: "#5b5b5b",
                  color: "#bdbdbd",
                },
              }}
            >
              Upload
            </Button>
          </Box>
        </Box>
            </Modal>
      )}
    </div>
  );
}

const FileUploader = forwardRef((props, ref) => {
  const [loading, setLoading] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [open, setOpen] = useState(false);
  const [isProfileNameSet, setIsProfileNameSet] = useState(false); // Track if profile name is set
  const [profileName, setProfileName] = useState('');
  const [documentType, setDocumentType] = useState("grantproposal");
  const [documentDescription, setDocumentDescription] = useState("");
  const { from, uid, sendDataToParent, grantProposalForm_id, client_Organization_id } = props;


  const [formData, setFormData] = useState({ 
    Grant_Proposal_Name: "",
    Company_Name: "",
  });


const [showFilesPanel, setShowFilesPanel] = useState(false);
const [clientFiles, setClientFiles] = useState([]);
const [showConfirm, setShowConfirm] = useState(false);


  useEffect(() => {
    if (props.from === "grantaide") {
      setOpen(true);
    } else {
      setOpen(false);
    }
    const fetchUploadedDocuments = async () => {
      try {
        const response = await fetch(`${baseurl}/gptRun/get-documents-firestore`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            uid,
            grantProposalForm_id,
            client_Organization_id
          })
        });

        const data = await response.json();
        if (response.ok) {
          const filesWithProperty = data.documents.map(file => ({ name: file }));
          setUploadedFiles(filesWithProperty);
        } else {
          console.error("Failed to fetch documents: ", data);
        }
      } catch (error) {
        console.log("Error fetching uploaded files: ", error);
      }
    };

    fetchUploadedDocuments();
  }, [props.from, uid, grantProposalForm_id, client_Organization_id]); //solve  missing dependency warning

  // const handleProfileNameSubmit = () => {
  //   if (profileName.trim() === "" || formData.Company_Name.trim()==='') {
  //     alert("Please Ensure Both Fields Are Filled Correctly");
  //   } else {
  //     setIsProfileNameSet(true); // Set profile name
  //     sendDataToParent({ Company_Name: formData.Company_Name }); // Send company name data to parent
  //     sendDataToParent({ profileName: profileName }); // Send profile name data to parent
  //   }
  //   handleClose()
  // };

  const handleProfileNameSubmit = () => {
    // if (profileName.trim() === "" || formData.Company_Name.trim()==='') {
    if (!profileName.trim() || !formData.Company_Name.trim()) {
        alert("Please Ensure Both Fields Are Filled Correctly");
    } else {
    // setIsProfileNameSet(true);
    // sendDataToParent({ Company_Name: formData.Company_Name });
    //  sendDataToParent({ profileName: profileName });
    // send both in one go, and mark it as coming from the modal
      sendDataToParent({
        source: "modal",
        profileName,
        Company_Name: formData.Company_Name
      });
      setIsProfileNameSet(true);
    }
    // handleClose();
  };

  const uploadToServer = async (files, uid, fileType, desc) => {
    console.log("🔥 About to upload, fileType =", fileType, "desc =", desc);
    const formData = new FormData();
    Array.from(files).forEach((file) => {
      formData.append("file", file);
    });
    if (!uid) {
      console.error("🚨 uploadToServer: missing uid!");
      return;
    }
    formData.append("uid", uid);
    formData.append("grantProposalForm_id", grantProposalForm_id);
    formData.append("client_Organization_id", client_Organization_id);

    formData.append("file_type", fileType);
    formData.append("description", desc);
    console.log("🔥 FormData entries:", Array.from(formData.entries()));
    console.log("coi" , client_Organization_id) ;
    try {
      const response = await fetch(`${baseurl}/gptRun/upload-copilot`, {
        method: "POST",
        body: formData,
      });
   
      const data = await response.json();
      if (response.ok) {
        console.log("File uploaded successfully: ", data);
      } else {
        console.error("Failed to upload file: ", data);
      }
    } catch (err) {
      console.error("Error uploading file: ", err);
    }
  }

const getFilesForClient =async () =>{
  try {
    const response = await fetch(`${baseurl}/gptRun/files/${client_Organization_id}?uid=${encodeURIComponent(uid)}`);
    if (!response.ok) {
      throw new Error(`Error fetching files: ${response.statusText}`);
    }
    const files = await response.json();
    return files; // return the list of files
  } catch (error) {
    console.error("Failed to fetch files:", error);
    throw error;
  }
}

const handleUploadFromGCS = async (file) => {
  const confirm = window.confirm(`Do you want to upload "${file.original_filename}" to this proposal?`);
  if (!confirm) return;    
    const downloadRes = await fetch(`${baseurl}/gptRun/download-from-gcs`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ gcs_uri: file.gcp_file_path }),
    });

    if (!downloadRes.ok) throw new Error("Failed to download file from GCS");

    const blob = await downloadRes.blob();
    const downloadedFile = new File([blob], file.original_filename, { type: "application/pdf" });

    // Immediately parse it using existing logic
    const createEvent = { target: { files: [downloadedFile] } };
    handleFileChange(createEvent);
};

  const handleClose = () => setOpen(false);

  const handleFileChange = async (event) => {
    const files = event.target.files;
    if (files.length === 0) return;
    const currentUid  = props.uid;
    const currentType = documentType;
    const currentDesc = documentDescription;
    

    setUploadedFiles((currentFiles) => [...currentFiles, ...files]);
    setOpen(false);
    const reader = new FileReader();
    const file = files[0];
    if (file.type === "application/pdf") {
      // uploadToServer(files);
      uploadToServer(files, currentUid, currentType, currentDesc);
      reader.onload = async (e) => {
        const typedArray = new Uint8Array(e.target.result);
        try {
          const pdfDoc = await pdfjsLib.getDocument(typedArray).promise;
          const textContentAllPages = [];

          const numPages = pdfDoc.numPages;
          for (let pageNum = 1; pageNum <= numPages; pageNum++) {
            const page = await pdfDoc.getPage(pageNum);
            const textContent = await page.getTextContent();
            const textItems = textContent.items
              .map((item) => item.str)
              .filter((line) => line.trim() !== "");
            textContentAllPages.push(...textItems);
          }

          const allText = textContentAllPages.join(" ");
          setLoading(true);
          // let response = await parseGrantProposalText(allText);
          // sendDataToParent(JSON.parse(response));

          //New
          let response = await parseGrantProposalText(allText);
          const parsed = JSON.parse(response);
          // Emit a 'file:parsed' event carrying the file name and its parsed content
          eventBus.emit("file:parsed", { name: file.name, data: parsed });
          // sendDataToParent(parsed);
          sendDataToParent({ source: "file", ...parsed });
          //EndNew

          if (!response) {
            throw new Error("Could not extract grant proposal text");
          }
        } catch (error) {
          console.log("Error reading PDF:", error);
        } finally {
          setLoading(false);
          setShowConfirm(true);
          setOpen(true);

        }
      };
    }
    reader.readAsArrayBuffer(file);
  };

  const hiddenInputRef = React.useRef(null);
  const handleAddFiles = () => {
    
    hiddenInputRef.current?.click();
    
  };
//   const handleAddFiles = async (files) => {
//   try {
//     document.getElementById("upload-button").click();
   
//     // setOpen(false);
//   } catch (error) {
//     console.error("Error fetching files:", error);
//   }
// };



useEffect(() => {
  if (open) {
    const fetchFiles = async () => {
      try {
        const files = await getFilesForClient(); // await the async function
        setClientFiles(files);                   // update state with returned files
        setShowFilesPanel(true);
      } catch (error) {
        console.error("Failed to fetch files:", error);
      }
    };
    fetchFiles();
  }
}, [open]);

  const handleDocumentTypeChange = (event) => {
    setDocumentType(event.target.value);
  };

  const handleDocumentDescriptionChange = (event) => {
    setDocumentDescription(event.target.value);
  };
  return (
    <div>
      <div
        className="cursor-pointer"
        onClick={() => setOpen(true)} // Open modal on click
      >
        <AddCircleOutlineIcon />
      </div>
  
      {loading && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            zIndex: 9999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress size={60} sx={{ color: "#fff" }} />
        </Box>
      )}
  
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box
          sx={{
            ...modalStyle,
            display: "flex",
            flexDirection: "column",
            height: "90vh"
          }}
        >
          {(from === "main" || isProfileNameSet) ? (
            <Box sx={{ display: "flex",  gap: 2, overflow: "hidden", p:5 }}>
              {/* Left Panel */}
              <Box sx={{ flex: 1, pr: 2, display: "flex", flexDirection: "column",  }}>
                <Typography
                  id="modal-title"
                  variant="h6"
                  component="h2"
                  color="white"
                  sx={{ textAlign: "center", mb: 2 }}
                >
                  Document Upload
                </Typography>
  
                <Box sx={{ flexGrow: 1 }}>
                  <FormControl fullWidth sx={{ px: 2 }}>
                    <RadioGroup
                      value={documentType}
                      onChange={handleDocumentTypeChange}
                      name="radio-buttons-group"
                    >
                      <FormControlLabel value="grantproposal" control={<Radio sx={{ color: 'white' }} />} label="Grant Proposal" />
                      <FormControlLabel value="grantqna" control={<Radio sx={{ color: 'white' }} />} label="(RFP) Request for Proposal" />
                      <FormControlLabel value="grantNofo" control={<Radio sx={{ color: 'white' }} />} label="(NOFO) Notice of Funding Opportunity" />
                      <FormControlLabel value="grantFinancialDoc" control={<Radio sx={{ color: 'white' }} />} label="Financial Document" />
                      <FormControlLabel value="other" control={<Radio sx={{ color: 'white' }} />} label="Other" />
                    </RadioGroup>
                  </FormControl>
  
                  <TextField
                    id="document-description"
                    label="Document Description"
                    multiline
                    rows={4}
                    value={documentDescription}
                    onChange={handleDocumentDescriptionChange}
                    variant="outlined"
                    fullWidth
                    sx={{ mt: 2 }}
                  />
                </Box>
  
                <Box
                  className="file-upload-btns"
                  sx={{
                    display: "flex",
                    justifyContent: "space-evenly",
                    mt: "auto",
                    pt: 2
                  }}
                >
                  <Button onClick={handleAddFiles} variant="contained" color="primary">
                    Add files
                  </Button>
                    
                  <VisuallyHiddenInput
                    ref={hiddenInputRef}
                    type="file"
                    multiple
                    accept=".pdf"
                    onChange={handleFileChange}
                  />

                  <Button onClick={handleClose} variant="contained" color="primary">
                    Cancel
                  </Button>
                </Box>
              </Box>
  
              {/* Right Panel */}
              {showFilesPanel && (
                <Box sx={{ flex: 1, minHeight: 0, maxWidth:"50%", }}>
                  <Typography variant="h6" sx={{ color: "white", mb: 2, textAlign: "center" }}>
                    Select a previously uploaded file
                  </Typography>
  
                  <Box
                    sx={{
                      maxHeight: "100%",
                      overflowY: "auto",
                      backgroundColor: "#1e1e1e",
                      p:2,
                      borderRadius: 2,
                    }}
                  >
                    {clientFiles.length === 0 ? (
                      <Typography sx={{ color: "white" }}>No files found.</Typography>
                    ) : (
                      <List>
                        {clientFiles.map((file, index) => (
                          <ListItem
                            key={index}
                            // component="a"
                            // target="_blank"
                            onClick={() => handleUploadFromGCS(file)} 
                            sx={{
                              backgroundColor: "#2c2c2c",
                              borderRadius: 1,
                              mb: 1,
                              color: "white",
                              px: "16px",
                              "& .MuiListItemIcon-root": { minWidth: "30px" },
                              "&:hover": { backgroundColor: "#3a3a3a" }
                            }}
                          >
                            <ListItemIcon>
                              <InsertDriveFileOutlinedIcon sx={{ color: "white" }} />
                            </ListItemIcon>
                            <Tooltip title={file.original_filename || `File ${index + 1}`} arrow>
                              <ListItemText
                                primary={file.original_filename || `File ${index + 1}`}
                                primaryTypographyProps={{
                                  noWrap: true,
                                  sx: {
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    flex: 1
                                  }
                                }}
                              />
                            </Tooltip>
                          </ListItem>
                        ))}
                      </List>
                    )}
                  </Box>
                </Box>
              )}
            </Box>
          ) : (
            <>
              <Box
                sx={{
                  p: 4,
                  maxWidth: 700,
                  width: "100%",
                  margin: "0 auto",
                  backgroundColor: "#1e1e1e",
                  borderRadius: 2
                }}
              >
                <Typography sx={{ textAlign: "center", mb: 4 }} variant="h6" color="white">
                  Please Enter Grant Proposal Details
                </Typography>
  
                <Box sx={{ mb: 3 }}>
                  <TextField
                    id="grant-proposal-name"
                    label="Grant Proposal Name"
                    value={profileName}
                    onChange={(e) => setProfileName(e.target.value)}
                    variant="outlined"
                    fullWidth
                    InputLabelProps={{ style: { color: "white" } }}
                    sx={{
                      input: { color: "white" },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": { borderColor: "white" },
                        "&:hover fieldset": { borderColor: "white" },
                        "&.Mui-focused fieldset": { borderColor: "white" }
                      }
                    }}
                  />
                </Box>
  
                <Box sx={{ mb: 3 }}>
                  <TextField
                    id="company-name"
                    label="Company Name"
                    value={formData.Company_Name}
                    onChange={(e) => setFormData(prev => ({ ...prev, Company_Name: e.target.value }))}
                    variant="outlined"
                    fullWidth
                    InputLabelProps={{ style: { color: "white" } }}
                    sx={{
                      input: { color: "white" },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": { borderColor: "white" },
                        "&:hover fieldset": { borderColor: "white" },
                        "&.Mui-focused fieldset": { borderColor: "white" }
                      }
                    }}
                  />
                </Box>
              </Box>
  
              <div className="file-upload-btns">
                <Button
                  onClick={handleProfileNameSubmit}
                  variant="contained"
                  color="primary"
                  sx={{ mt: 2 }}
                >
                  Submit Grant Proposal Name
                </Button>
              </div>
            </>
          )}
        </Box>
      </Modal>
      <Modal
        open={showConfirm}
        onClose={() => setShowConfirm(false)}
        aria-labelledby="confirm-title"
        aria-describedby="confirm-description"
      >
        <Box
          sx={{
            ...modalStyle,
            bgcolor: "#380093",
            maxWidth: 450,
            top: "35%",    
            mx: "auto",
            my: 8,
            textAlign: "center",
            p: 3
          }}
        >
          <Typography
            id="confirm-title"
            variant="h6"
            color="white"
            gutterBottom
          >
            Would you like to add another document?
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "center", gap: 6, mt: 2 }}>
            <Button
              variant="contained"
              onClick={() => {
                setShowConfirm(false);
                setOpen(true);    // just in case
              }}
            >
              Yes
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                setShowConfirm(false);
                handleClose();
              }}
            >
              No
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
  
});

export default FileUploader; 